import { toNum, toUTC } from '../../lib/transformValues';
import { importTypes } from './importTypes';
import {
  accountKeys,
  companyAccountKeys,
  individualMeterKeys,
  ownerKeys,
} from './settingStepFieldKeys';

const defaultAddressTypeId = 3;

const ownerTransformFns = {
  [ownerKeys.addressType]: toNum,
};

const accountTransformFns = {
  [accountKeys.addressType]: toNum,
  [accountKeys.accountType]: toNum,
};

const individualMetersTransformFns = {
  [individualMeterKeys.addressType]: toNum,
  [individualMeterKeys.serviceType]: toNum,
  [individualMeterKeys.location]: toNum,
  [individualMeterKeys.readDateTime]: toUTC,
  [individualMeterKeys.reading1]: toNum,
  [individualMeterKeys.reading2]: toNum,
  [individualMeterKeys.reading3]: toNum,
  [individualMeterKeys.installationDateTime]: toUTC,
  [individualMeterKeys.commissioningDateTime]: toUTC,
  [individualMeterKeys.verificationDateTime]: toUTC,
  [individualMeterKeys.verificationInterval]: toNum,
  [individualMeterKeys.status]: toNum,
};

const transformConfig = {
  [importTypes.owners]: ownerTransformFns,
  [importTypes.personalAccounts]: accountTransformFns,
  [importTypes.individualMeters]: individualMetersTransformFns,
};

const transformItems = ({ items, transformFns }) =>
  items.map((item) =>
    Object.entries(item).reduce((acc, entry) => {
      const { 0: key, 1: value } = entry;

      if (value) {
        const transform = transformFns[key];
        const val = transform ? transform(value) : value;
        acc[key] = val;
      }

      return acc;
    }, {})
  );

export const itemsToFetchTransforms = {
  [importTypes.owners]: (items) =>
    transformItems({
      items,
      transformFns: transformConfig[importTypes.owners],
    }),

  [importTypes.personalAccounts]: (items) =>
    transformItems({
      items,
      transformFns: transformConfig[importTypes.personalAccounts],
    }),

  [importTypes.personalAccountsByCompanies]: (items) =>
    items.map((item) => ({
      ...item,
      [companyAccountKeys.balance]: toNum(item[companyAccountKeys.balance]),
      addressTypeId: defaultAddressTypeId,
    })),

  [importTypes.individualMeters]: (items) =>
    transformItems({
      items,
      transformFns: transformConfig[importTypes.individualMeters],
    }),
};
